var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuLicensing = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  baseProfile: "tiny",
  id: "Licensing_1_",
  x: "0px",
  y: "0px",
  viewBox: "0 0 24 24",
  overflow: "visible",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "#FFFFFF",
  d: "M13.02,23.01v0.02H1.01v-6.03h2.63c0.02-0.39,0.14-0.78,0.39-1.11 c0.13-0.17,0.28-0.46,0.28-0.84h0c0-0.02,0-0.04,0-0.06c0.01-0.58-0.16-1.13-0.47-1.5c-0.8-0.99-1.08-2.27-0.78-3.53 C3.43,8.52,4.57,7.41,6,7.05L6-0.01h9.47l8.55,8.6v14.42H13.02z M3.01,19v2.01h8V19H3.01z M6.55,8.96C5.81,9.11,5.2,9.7,5.02,10.43 C4.86,11.08,5,11.72,5.41,12.22c1.01,1.25,0.9,2.77,0.91,2.82c0,0.73-0.23,1.4-0.62,1.95H8.3c-0.39-0.55-0.62-1.22-0.62-1.95 c0.01-0.04-0.1-1.37,1-2.94c0.24-0.34,0.36-0.74,0.36-1.15c0-1.12-0.9-2.05-2.05-2.04C6.85,8.91,6.7,8.93,6.55,8.96z M16.02,3.48 v4.51h4.52L16.02,3.48z M21.99,10.02h-7.96v-8h-6l0,5.04c1.73,0.46,3.02,2.02,3.02,3.9c0,0.83-0.25,1.62-0.72,2.3 c-0.6,0.86-0.64,1.55-0.64,1.74c0,0.02,0,0.03,0,0.05c0,0.39,0.15,0.67,0.28,0.84c0.25,0.33,0.37,0.71,0.39,1.11h2.67v3.98h8.97 V10.02z M19.99,15H14v-2h5.99V15z M19.99,19H16v-2h3.99V19z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuLicensing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_Licensing.1a5655f0.svg";
export { ForwardRef as ReactComponent };